import { useState, useEffect } from 'react'
import { useAuth } from '../contexts/auth'
import { useQuery } from '@tanstack/react-query'
import { getMembershipsKey, getMemberships } from '../api-client/listing/get-memberships'

export default function useMemberships() {
  const [memberships, setMemberships] = useState({})
  const [{ isAuthenticated }] = useAuth()

  const { refetch } = useQuery({
    queryKey: [getMembershipsKey],
    queryFn: getMemberships,
    enabled: isAuthenticated,
    onSuccess: (data) => {
      setMemberships(data)
    },
  })
  useEffect(() => {
    if (!isAuthenticated && Object.keys(memberships).length > 0) {
      setMemberships({})
    }
  }, [isAuthenticated, memberships])

  return [memberships, refetch]
}
